<template>
    <div>

        <div v-if="preInscriptionMaxiraceStore.loading">
            <div class="text-center">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                <v-skeleton type="table-row" />
                <v-skeleton type="table-row" />
                <v-skeleton type="table-row" />
            </div>
        </div>
        <div v-else>
            <div v-if="preInscriptionMaxiraceStore.redered_selection">
                <div class="d-flex sm-gap align-center justify-space-between">
                    <div class="d-flex sm-gap">
                        <SportipsButton icon="mdi-check-all" @click="selectAll()" :loading="loading_select">Tout
                            selectionner</SportipsButton>
                        <SportipsButton icon="mdi-square-off-outline" @click="selectNone()" :loading="loading_select">
                            Tout déselectionner
                        </SportipsButton>
                    </div>
                    <div>{{ readable_count_selected }}</div>
                </div>



                <v-data-table-virtual class="preinscription-list-table" density="compact" :headers="headers"
                    :items="preInscriptionMaxiraceStore.redered_selection" height="1000" item-value="name" fixed-header>

                    <!-- Template pour les informations supplémentaires -->
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>
                                <v-checkbox :model-value="item.flagged" @mousedown="onFlagMouseDown($event)"
                                    @update:model-value="onFlagChange($event, item)" color="primary"
                                    hide-details></v-checkbox>
                            </td>
                            <td>
                                <v-btn :icon="expanded.includes(item.id) ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                                    color="darkblue" variant="text" density="compact" @click="toggleExpansion(item.id)"
                                    :aria-label="`Plus d'informations sur ${item.nom} ${item.prenom}`">
                                </v-btn>
                            </td>
                            <td>
                                <div class="d-flex sm-gap align-center">

                                    <img v-if="item.metadatas.nationalite"
                                        :src="'https://sportips.fr/Flags/' + item.metadatas.nationalite + '.jpg'"
                                        alt="Nationalité" width="20" height="20" class="rounded">{{ item.nom }} {{
                                            item.prenom }}
                                    <v-icon v-if="item.sexe == 'M'" icon="mdi-gender-male"
                                        color="light-blue-darken-4"></v-icon>
                                    <v-icon v-else icon="mdi-gender-female" color="deep-purple"></v-icon>
                                </div>
                            </td>
                            <td>
                                {{ preInscriptionMaxiraceStore.getCourseNameByID(item.id_course) }}
                            </td>
                            <td>
                                <div v-for="option in item.options" :key="option.id">
                                    <b>{{ option.quantite }}x</b> {{ option.nom }}
                                </div>

                            </td>
                            <td class="d-flex sm-gap align-center">
                                <v-chip color="darkblue" variant="tonal" density="compact"
                                    class="px-1 d-flex sm-gap align-center">
                                    <span class="font-weight-bold">{{ item.betrail / 100 }}</span>
                                    <img :src="require(`@/assets/img/betrail_logo.png`)" class="betrail_chip ml-1" />

                                </v-chip>
                                <v-chip color="darkblue" variant="tonal" density="compact"
                                    class="px-1 d-flex sm-gap align-center">
                                    <span class="font-weight-bold">{{ item.cote_itra }}</span>
                                    <img :src="require(`@/assets/img/logo_itra.png`)" class="betrail_chip ml-1" />
                                </v-chip>
                            </td>

                        </tr>
                        <!-- Ligne d'expansion -->
                        <tr v-if="expanded.includes(item.id)">
                            <td colspan="6" class="pa-0">
                                <div class="pa-4 bg-grey-lighten-5">
                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <div>Code postal : <b>{{ item.metadatas.cp }}</b></div>
                                            <div>Pays : <b>{{ item.metadatas.pays }}</b></div>
                                            <div>Nationalité : <b>{{ item.metadatas.nationalite }}</b></div>
                                            <div>Participation MaxiRace : <b>{{ get_text_participation_maxi(item) }}</b>
                                            </div>
                                            <div>Participation Madère : <b>{{ get_text_participation_madere(item) }}</b>
                                            </div>
                                            <div>Participation Plaintel : <b>{{ get_text_participation_plaintel(item)
                                            }}</b>
                                            </div>
                                            <div>Participation Martigue-Carro : <b>{{
                                                get_text_participation_martigue_carro(item) }}</b></div>






                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <div>Moyen de locomotion : <b>{{ item.metadatas.moyen_locomotion }}</b>
                                            </div>
                                            <div>Vient avec famille : <b>{{ get_text_vient_avec_famille(item) }}</b>
                                            </div>
                                            <div>Vient entre copains : <b>{{ get_text_vient_entre_copains(item) }}</b>
                                            </div>
                                            <div>A une assistance : <b>{{ get_text_assistance_ravitaillement(item)
                                            }}</b>
                                            </div>
                                            <div>Inscription groupe partenaire : <b>{{
                                                get_text_inscription_groupe_partenaire(item) }}</b></div>
                                            <div>Inscription groupe amis : <b>{{ item.metadatas.inscription_groupe_amis
                                                ==
                                                "1" ? "Oui" : "Non" }}</b></div>

                                        </v-col>
                                    </v-row>
                                    <div v-if="item.associated.length > 0">
                                        <div><u>Inscriptions associées sur la commande:</u></div>
                                        <div v-for="associated in item.associated" :key="associated.id">

                                            <div class="d-flex sm-gap align-center">
                                                <v-icon v-if="associated.sexe == 'M'" icon="mdi-gender-male"
                                                    color="light-blue-darken-4"></v-icon>
                                                <v-icon v-else icon="mdi-gender-female" color="deep-purple"></v-icon>
                                                {{ associated.nom }}
                                                {{ associated.prenom }}

                                                sur {{
                                                    preInscriptionMaxiraceStore.getCourseNameByID(associated.id_course)
                                                }}
                                                {{ get_associated_options(associated) }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>

                </v-data-table-virtual>


            </div>

        </div>


    </div>
</template>

<script>
import { mapStores } from "pinia";
import { usePreInscriptionMaxiraceStore } from "@/stores/specific/preInscriptionMaxirace";
export default {
    computed: {
        ...mapStores(usePreInscriptionMaxiraceStore),
        readable_count_selected() {
            let response = "";
            if (this.preInscriptionMaxiraceStore.total_match_query >= 300) {
                response = "Affichage de 300/" + this.preInscriptionMaxiraceStore.total_match_query + " résultats";
            } else {
                response = this.preInscriptionMaxiraceStore.selection.length + " résultats";
            }
            if (this.preInscriptionMaxiraceStore.total_match_query_associated > 0) {
                response += " (+ " + this.preInscriptionMaxiraceStore.total_match_query_associated + " résultats associés)";
            }
            return response;
        }
    },
    data() {
        return {
            expanded: [],
            loading_select: false,
            lastClickedId: null,
            shiftClickActive: false,
            headers: [
                { title: "", key: "selectionner", sortable: false, align: 'start' },
                { title: "Détails", key: 'plus_informations', sortable: false, align: 'start' },
                { title: 'Coureur', key: 'coureur', sortable: false, align: 'start' },
                { title: 'Course', key: 'course', sortable: false, align: 'start' },
                { title: 'Options', key: 'options', sortable: false, align: 'start' },
                { title: 'Cotations', key: 'cotations', sortable: false, align: 'start' },
            ],
        }
    },
    methods: {
        get_text_participation_maxi(inscription) {
            let response = "Aucune participation";
            if (inscription.metadatas.a_participe_maxi == "1") {
                response = "Oui";
            }
            if (inscription.metadatas.nb_participation_maxi > 0) {
                response += " " + inscription.metadatas.nb_participation_maxi + " fois";
                if (inscription.metadatas.participation_maxi_annee) {
                    response += " (en " + inscription.metadatas.participation_maxi_annee + ")";
                }
            }
            return response;
        },
        get_text_participation_madere(inscription) {
            let response = "Aucune participation";
            if (inscription.metadatas.a_participe_madere == "1") {
                response = "Oui";
            }
            if (inscription.metadatas.participation_madere_annee) {
                response += " (en " + inscription.metadatas.participation_madere_annee + ")";
            }
            return response;
        },
        get_text_participation_plaintel(inscription) {
            let response = "Aucune participation";
            if (inscription.metadatas.a_participe_plaintel == "1") {
                response = "Oui";
            }
            if (inscription.metadatas.participation_plaintel_annee) {
                response += " (en " + inscription.metadatas.participation_plaintel_annee + ")";
            }
            return response;
        },
        get_text_participation_martigue_carro(inscription) {
            let response = "Aucune participation";
            if (inscription.metadatas.a_participe_martigues == "1") {
                response = "Oui";
            }
            if (inscription.metadatas.participation_martigues_annee) {
                response += " (en " + inscription.metadatas.participation_martigues_annee + ")";
            }
            return response;
        },
        get_text_vient_avec_famille(inscription) {
            let response = "Non";
            if (inscription.metadatas.vient_avec_famille == "1") {
                response = "Oui";
            }
            if (inscription.metadatas.nb_personne_famille) {
                response += " (" + inscription.metadatas.nb_personne_famille + " personnes)";
            }
            return response;
        },
        get_text_vient_entre_copains(inscription) {
            let response = "Non";
            if (inscription.metadatas.vient_entre_copain == "1") {
                response = "Oui";
            }
            if (inscription.metadatas.nb_copains) {
                response += " (" + inscription.metadatas.nb_copains + " personnes)";
            }
            return response;
        },
        get_text_assistance_ravitaillement(inscription) {
            let response = "Non";
            if (inscription.metadatas.assistance_ravitaillement == "1") {
                response = "Oui";
            }
            if (inscription.metadatas.locomotion_assistance) {
                response += " (Locomotion : " + inscription.metadatas.locomotion_assistance + ")";
            }
            return response;
        },
        get_text_inscription_groupe_partenaire(inscription) {
            let response = "Non";
            if (inscription.metadatas.inscription_groupe_partenaire == "1") {
                response = "Oui";
            }
            if (inscription.metadatas?.code_groupe_partenaire) {
                response += " (Code groupe: " + inscription.metadatas.code_groupe_partenaire + ")";
            }
            return response;
        },
        get_associated_options(inscription) {

            if (inscription.options.length == 0) {
                return " - Aucune option";
            }
            let response = " | ";
            for (const option of inscription.options) {
                response += option.quantite + "x " + option.nom + ", ";
            }
            return response;
        },
        toggleExpansion(itemId) {
            const index = this.expanded.indexOf(itemId);
            if (index > -1) {
                this.expanded.splice(index, 1);
            } else {
                this.expanded.push(itemId);
            }
        },
        onFlagMouseDown(event) {
            this.shiftClickActive = event.shiftKey;
            if (event.shiftKey) {
                document.getSelection()?.removeAllRanges();
            }
        },
        onFlagChange(flagged, item) {
            const items = this.preInscriptionMaxiraceStore.redered_selection || [];
            const index = items.findIndex((row) => row.id === item.id);
            if (this.shiftClickActive && this.lastClickedId != null) {
                const anchorIndex = items.findIndex((row) => row.id === this.lastClickedId);
                if (anchorIndex !== -1 && index !== -1) {
                    const start = Math.min(anchorIndex, index);
                    const end = Math.max(anchorIndex, index);
                    const ids = items.slice(start, end + 1).map((row) => row.id);
                    this.preInscriptionMaxiraceStore.setFlaggedForIds(ids, flagged);
                    this.lastClickedId = item.id;
                    this.shiftClickActive = false;
                    return;
                }
            }
            this.preInscriptionMaxiraceStore.setFlaggedForIds([item.id], flagged);
            this.lastClickedId = item.id;
            this.shiftClickActive = false;
        },
        selectAll() {
            this.loading_select = true;
            this.preInscriptionMaxiraceStore.selectAll();
            this.loading_select = false;
        },
        selectNone() {
            this.loading_select = true;
            this.preInscriptionMaxiraceStore.selectNone();
            this.loading_select = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.betrail_chip {
    width: auto;
    height: 15px;
}

.preinscription-list-table {
    user-select: none;
}
</style>